<template>
  <div>
    <el-form :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="电汇编号:">
        <el-input v-model.trim="searchForm.telegraphicTransferNum" placeholder="请输入电汇编号" />
      </el-form-item>
      <el-form-item label="汇入公司:">
        <el-select v-model="searchForm.accountCompany" placeholder="请选择" clearable>
          <el-option
            v-for="item in companyList"
            :key="item.dictValue"
            :label="item.dictLabel"
            :value="item.dictValue"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="申请日期:">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="isTableLoading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <div v-loading="isTableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
        <el-table-column label="电汇底单编号" align="left" fixed="left" min-width="110">
          <template v-slot="{row}">
            <el-button type="text" @click="lookTelegraphicTransfer(row)">
              {{ row.telegraphicTransferNum }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="remittanceAmount" label="汇款金额(元)" align="right" header-align="left" width="100" />
        <el-table-column prop="account" label="汇入账户" align="left" />
        <el-table-column prop="accountCompany" label="汇入公司" align="left" />
        <el-table-column prop="unusedAmount" label="可用余额(元)" align="right" header-align="left" width="100">
          <template v-slot="{row}">
            <span>{{ row.unusedAmount == null ? 0 : row.unusedAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="returnAmount" label="申请退款金额(元)" align="right" header-align="left" />
        <el-table-column prop="applicationTime" label="申请日期" width="140" align="left" />
        <el-table-column prop="stateAndApprover" label="当前状态" align="left" />
        <el-table-column prop="date" label="操作" width="120" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button type="text" @click="lookDetail(row)">
              查看
            </el-button>
            <el-button v-if="row.state === '驳回待提交'" type="text" @click="editRefund(row)">
              编辑
            </el-button>
            <el-button v-if="row.state === '驳回待提交'" type="text" @click="abandonmentFn(row)">
              废弃
            </el-button>
            <el-button v-if="['待商务审核', '待财务审核'].includes(row.state)" type="text" @click="recallFn(row)">
              召回
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <!-- 查看 电汇底单编号 -->
    <telegraphic-transfer-detail ref="telegraphicTransferDetail" />

    <!-- 召回 -->
    <recall-dialog ref="recallDialog" @on-ok="queryData" />

    <!-- 查看 -->
    <refund-detail-dialog ref="refundDetailDialog" />

    <!-- 编辑 -->
    <edit-refund-dialog ref="editRefundDialog" @on-ok="queryData" />
  </div>
</template>

<script>
import TelegraphicTransferDetail from './TelegraphicTransferDetail.vue';
import RecallDialog from './RecallDialog.vue';
import RefundDetailDialog from './RefundDetailDialog.vue';
import EditRefundDialog from './EditRefundDialog.vue';
import { selectTelApplyRefund, abandonRefund, getDictData } from '@/API';

export default {
  components: {
    TelegraphicTransferDetail,
    RecallDialog,
    RefundDetailDialog,
    EditRefundDialog
  },

  data () {
    return {
      companyList: [],
      searchForm: {
        telegraphicTransferNum: '',
        accountCompany: '',
        createBeginTime: '',
        createEndTime: ''
      },
      isTableLoading: false,
      tableData: [],
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },

  created () {
    this.querySelectData();
    this.queryData();
  },

  methods: {
    querySelectData () {
      getDictData(['bank_name']).then((res) => {
        const { status, data } = res.data;
        if (status === '200') {
          this.companyList = data.find(row => row.dictType === 'bank_name').dictDataVOS;
        }
      });
    },

    doSearch () {
      this.currentPage = 1;
      this.queryData();
    },

    resetForm () {
      this.searchForm.createEndTime = '';
      this.searchForm = {
        telegraphicTransferNum: '',
        accountCompany: '',
        createBeginTime: '',
        createEndTime: ''
      };
      this.queryData();
    },

    // 改变每页条数 当前页回到第一页
    handerSizeChange (val) {
      this.page.currentPage = 1;
      this.doSearch();
    },

    // 改变当前页
    handerCurrentChange (val) {
      this.doSearch();
    },

    queryData () {
      this.isTableLoading = true;
      let params = {
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      };

      selectTelApplyRefund(params)
        .then((res) => {
          this.isTableLoading = false;
          let { status, data } = res.data;
          if (status === '200') {
            this.tableData = data.list;
            this.page.total = data.total;
          }
        }).catch(() => {
          this.isTableLoading = false;
        });
    },

    // 查看 电汇底单编号
    lookTelegraphicTransfer (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.telegraphicTransferDetail.openDialog(data);
    },

    // 查看
    lookDetail (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.refundDetailDialog.openDialog(data);
    },

    // 编辑
    editRefund (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.editRefundDialog.openDialog(data);
    },

    // 召回
    recallFn (row) {
      let data = JSON.parse(JSON.stringify(row));
      this.$refs.recallDialog.openDialog(data);
    },

    // 废弃
    abandonmentFn ({ telApprovalId }) {
      this.$confirm('废弃后申请的退款金额将返还到电汇单上，你确定要废弃此退款申请吗？', '', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          abandonRefund({ telApprovalId }).then((res) => {
            let { status } = res.data;
            if (status === '200') {
              this.$message.success('废弃成功');
              this.queryData();
            }
          });
        })
        .catch(() => {});
    }
  }

};
</script>
